import { LocationNumbersService } from '../../../services'

const fetchPhoneNumbersSID = async function (
  { commit },
  locationId
) {
  try {
    const data = await LocationNumbersService.getPhoneNumbersSID(
      locationId
    )

    commit('setPhoneNumbersSID', data)
    return Promise.resolve(data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export default fetchPhoneNumbersSID
